
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.183 9.792h-2.85a.63.63 0 01-.625-.625V3.342c0-.617.242-1.192.675-1.625a2.282 2.282 0 011.625-.675h.009A3.968 3.968 0 0117.792 2.2 3.97 3.97 0 0118.95 5v2.017c.008 1.658-1.108 2.775-2.767 2.775zm-2.225-1.25h2.225c.967 0 1.525-.559 1.525-1.525V5c0-.717-.283-1.4-.791-1.917a2.76 2.76 0 00-1.9-.791h-.009c-.275 0-.541.108-.741.308-.2.2-.309.458-.309.742v5.2z","fill":"#fff"}}),_c('path',{attrs:{"d":"M7.5 19.442c-.392 0-.759-.15-1.034-.434l-1.383-1.391a.205.205 0 00-.275-.017l-1.425 1.067a1.444 1.444 0 01-1.525.141c-.5-.25-.808-.75-.808-1.308V5c0-2.517 1.441-3.958 3.958-3.958h10a.63.63 0 01.625.625.63.63 0 01-.625.625c-.575 0-1.041.466-1.041 1.041V17.5c0 .558-.309 1.058-.809 1.308s-1.083.2-1.525-.133l-1.425-1.067a.202.202 0 00-.267.017l-1.4 1.4c-.283.267-.65.417-1.041.417zm-2.575-3.134c.383 0 .758.142 1.041.434l1.384 1.391c.05.05.116.059.15.059-.009-.017.1-.009.15-.059l1.4-1.4a1.45 1.45 0 011.908-.125l1.417 1.059a.19.19 0 00.216.016c.042-.025.117-.075.117-.183V3.333c0-.375.092-.733.25-1.041H5C3.15 2.292 2.29 3.15 2.29 5v12.5c0 .117.075.167.117.192.05.025.133.041.217-.025L4.05 16.6c.258-.192.566-.292.875-.292z","fill":"#fff"}}),_c('path',{attrs:{"d":"M9.792 8.958H5.208a.63.63 0 01-.625-.625.63.63 0 01.625-.625h4.584a.63.63 0 01.625.625.63.63 0 01-.625.625z","fill":"#fff"}})])
          )
        }
      }
    